import { Stack } from "@mui/material"
import BookingInfoComponent from "../BookingInfoComponent"
import { useRecordContext } from "react-admin"
import { InvoiceReadModel } from "../../GeneratedClients/FreeBillApi"
import Comments from "../Comments"
import ChildDocuments from "../ChildDocuments"

interface IProps {
  resource: "invoices" | "drafts" | "reverseInvoices" | "invoiceReminders"
  isPreview: boolean
}

const InvoiceInfo = ({resource, isPreview}: IProps) => {
  
  const invoice = useRecordContext<InvoiceReadModel>()
  if(!invoice) return null

  return (
    <Stack spacing={3} minWidth={500} maxWidth={"210mm"}>
      { invoice.bookingInfos && <BookingInfoComponent /> }
      { !isPreview && <Comments resource={resource} comments={invoice.comments} /> } 
      {
        resource === "invoices" && !isPreview && (invoice.isCanceled || (invoice.reminderStepNumber && invoice.reminderStepNumber > 0)) &&
        <ChildDocuments />
      }
    </Stack>
  )
}

export default InvoiceInfo